import '../sass/style.scss';
import customSelect from 'custom-select';
import 'custom-select/src/css/custom-select.css';

function scrollInto($el) {
    $('html, body').animate({ scrollTop: $el.offset().top}, 1000);
}

function getCity(cities, city_id) {
    return cities.find((city) => city.id === parseInt(city_id));
}

function setPrice(price) {
    // noinspection JSUnresolvedFunction
    $('#price').text(Intl.NumberFormat('ru-RU', {'currency': 'RUB'}).format(price));
}

$(document).ready(() => {
    $('a').click(function() {
        let href = $(this).attr('href');
        if (href && href.length > 1 && href[0] === '#') {
            scrollInto($(href));
        }
    });

    if ($('#section-main').length) {
        let city = JSON.parse($('#city').text());
        const cities = JSON.parse($('#cities').text());

        let $idCity = $('#id_city');
        let $selectCity = $('.select-city');
        if (city) {
            $selectCity.val(city.id);
            // noinspection JSUnresolvedVariable
            setPrice(city.price);
        }

        // noinspection JSValidateTypes
        const selectCity = customSelect($selectCity);
        $selectCity.change((event) => {
            city = getCity(cities, event.target.value);
            if (city) {
                // noinspection JSUnresolvedVariable
                $idCity.val(city.city);
                // noinspection JSUnresolvedVariable
                setPrice(city.price);
            }
        })
        // noinspection JSUnresolvedFunction
        new Inputmask('+7 (999) 999-99-99').mask($('#id_phone'));

        // noinspection JSUnresolvedVariable
        $idCity.autocomplete({
            lookup: cities.map((city) => ({value: city.city, data: city.id})),
            minChars: 0,
            onSelect: function (suggestion) {
                city = getCity(cities, suggestion.data);
                if (city) {
                    selectCity.forEach((select) => {
                        select.value = city.id;
                    })
                    // noinspection JSUnresolvedVariable
                    setPrice(city.price);
                }
            },
        })

        $('#form').submit(function (event) {
            let $form = $(this);
            const data = $(this).serialize();
            const $button = $(this).find('button[type=submit]');

            event.preventDefault();
            $button.prop('disabled', true);
            $.ajax({
                type: 'POST',
                data: data,
            }).done((response) => {
                if (response.success === 1) {
                    $form.find('input[type=text][name!=csrfmiddlewaretoken]').val('')
                    alert('Заявка отправлена!');
                }
                else {
                    alert('Ошибка!');
                }
            }).fail(() => {
                alert('Ошибка!');
            }).always(() => {
                $button.prop('disabled', false);
            })
        })
    }
});
